import { render, staticRenderFns } from "./DownloadsView.vue?vue&type=template&id=04b4d020"
import script from "./DownloadsView.vue?vue&type=script&lang=js"
export * from "./DownloadsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports